import type { PageSegmentLoadMetric } from '@atlassian/browser-metrics/page-segment-load';

import { createPageSegmentLoadMetric } from '@confluence/browser-metrics/entry-points/metricConfigs.ts';
import { PAGE_COMMENTS_SEGMENT_KEY } from '@confluence/browser-metrics/entry-points/metric-keys.ts';

export const PAGE_COMMENTS_METRIC: PageSegmentLoadMetric = createPageSegmentLoadMetric({
	key: PAGE_COMMENTS_SEGMENT_KEY,
	timings: [
		{
			key: 'fmp',
			endMark: 'fmp',
		},
		{
			key: 'tti',
			endMark: 'tti',
		},
		{
			key: 'pageCommentsRender',
			startMark: 'pageCommentsRenderStart',
			endMark: 'pageCommentsRenderEnd',
		},
	],
});
